export const dateFormat = 'DD/MM/YYYY';
export const endpoint = '/reports/damage';
export const tableName = 'dashboardContainersDamage';



// WEBPACK FOOTER //
// ./src/containers/DashboardContainersDamage/constants.js